<template>
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            trackCode='receivablesReceiptList-1'
            @reset="handleReset"
          >
            <template slot="batch-search-btn">
              <el-button
                type="primary"
                :size="formSize"
                :loading="loading"
                @click="handleBatchSearch()"
              >
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList">
            <template #receiptMode>
              <page-select-cascader
                ref="receiptModeRef"
                :selectList="queryForm.selectList"
                :selectOptions="receiptModeOptions"
                :cascaderStyle="{minWidth: '260px'}"
                :cascaderProps="receiptModeProps"
                :hasAll="false"
                @change="cascaderChange"
              />
            </template>
          </page-select-groups>
          <!-- 导出报表按钮 -->
          <div class="fan-search-col fan-search-right">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              :recommendedColumn="recommendedColumn"
              @confirm="handleConfirm"
            />
            <template v-if="$has('FWS-SFKGL-SKD-DC')">
              <!-- <page-export-button
                title="收款单导出"
                exportServe="fin_receipt_receiptReport"
                :total="total"
                :isLimit="true"
                :exportParams="exportParams"
                trackCode="receivablesReceiptList-3"
              > -->
              <page-export-button
                title="收款单导出"
                exportServe="fin_receipt_receiptReport"
                :total="total"
                :exportParams="exportParams"
                @close="onCloseExport"
                :hasDate="false"
                :customMain="true"
                trackCode="receivablesReceiptList-3"
              >
                <template v-slot:main>
                  <data-show label="导出类型:">
                    <el-radio v-model="exportType" label="order">按订单类型</el-radio>
                    <el-radio v-model="exportType" label="bill">按账单类型</el-radio>
                  </data-show>
                </template>
              </page-export-button>
            </template>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          ref="receiptListRef"
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
        >
          <template v-slot:orderNumber="{row}">
            <jr-tooltip
              :content="row.orderNumber"
              type="popover"
              :isFilter="true"
            />
          </template>
          <template v-slot:certificate="{row}">
            <span v-if="!row.certificate">-</span>
            <preview-image
              v-else
              :row-id="row.id"
              :image-list="$stringToArray(row.certificate)"
            />
          </template>
          <template v-slot:waitDivideAmount="{row}">
            <!-- divideFlag 0-不分账，1-分账 -->
            <div v-if="row.divideFlag === 1">{{row.waitDivideAmount | toFenThousandsAndFloat}}</div>
            <div v-else>无需分账</div>
          </template>
        </jr-table>
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 确认/取消确认弹窗 -->
    <operate-state
      :visible.sync="isOperateStateShow"
      :receipt-obj.sync="receiptObj"
      :text-config.sync="textConfig"
      @success="handleOperateStateResults()"
    />
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :searchType="queryForm.searchType"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
      trackCode="receivablesReceiptList-2"
    />
    <!-- 金融收款 弹窗确认 -->
    <receiptDialog
      :visible.sync="receiptShow"
      :receipt-obj="receiptObj"
      :receipt-no="receiptObj.receiptNo"
      @success="getList"
    />

    <!-- 取消弹窗 -->
    <jr-operate-dialog
      :visible.sync="isOperateCancelShow"
      :data-obj.sync="receiptObj"
      :text-config.sync="textConfig"
      :loading="cancelLoading"
      @submit="cancelReceipt"
    />
    <!-- 收款单详情 -->
    <detail
      :visible.sync="isDetailShow"
      :receipt-no.sync="receiptNo"
    />
  </div>
</template>

<script>
import { getReceiptList } from '@/api/receivables/receipt';
import receiptMixins from './mixins/receipt'; // 收款单模块
import * as _ from 'lodash';
import previewImage from '@/components/jr-preview/preview-image';
import { setStatusColor } from '@/filters/index';
import { getMonthDate } from '@/utils/date';
import detail from '../components/receipt-detail';

const formDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  searchKey: '', // 搜索值
  searchType: 'orderNumber',
  receiveStatus: '',
  verifiedStatus: '',
  serviceType: '', // 服务商类型
  receiptNo: '', // 收款单编号
  type: '', // 类型
  paymentMethods: '', // 收款方式（旧）
  isHspecial: '', // 是否H单
  transType: 2, // 订单交易类型1=自营2=服务商
  timeType: '1',
  selectList: [],
  channels: '',
  receiptMode: '', // 收款方式
};

const dictTypes = {
  serviceType: '/common/general/serviceType',
  FinReceiveTypeEnum: '/finance/finance-receipt/FinReceiveTypeEnum',
  FinReceiptStatusEnum: '/finance/finance-receipt/FinReceiptStatusEnum',
  FinReceiptModelEnum: '/finance/finance-receipt/FinReceiptModelEnum',
  FinReceiptModelEnum_v2: '/finance/finance-receipt/FinReceiptModelEnum',
};

export default {
  name: 'ReceivablesReceiptList',
  mixins: [receiptMixins],
  components: { detail, previewImage },
  data() {
    const list = [
      {
        value: 'orderNumber',
        label: '业务订单编号',
      }, {
        value: 'receiptNo',
        label: '收款单编号',
      },
      {
        value: 'recApplyNo',
        label: '申请单号',
      },
    ];
    return {
      receiptModeProps: {
        multiple: true,
        checkStrictly: true,
        value: 'value',
        label: 'codeName',
        children: 'childs',
      },
      loading: false,
      queryForm: JSON.parse(JSON.stringify(formDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
            { label: '收款确认时间', value: '2' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchKey',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [
            ...list,
            {
              value: 'recBusinessName',
              label: '客户名称',
            },
            {
              value: 'recAccountName',
              label: '收款户名',
            },
          ],
        },
      ],
      // 批量搜索搜索条件集合
      batchSearchTypeList: [...list],
      /** ------批量搜索---- */
      isBatchSearchShow: false, // 批量搜索
      batchResults: {}, // 批量操作返回结果
      sourceList: [], // 归属业务
      tableColumn: [
        {
          prop: 'receiptNo',
          label: '收款单编号',
          minWidth: '1',
          disabled: true,
          trackCode: 'receivablesReceiptList-6',
          permission: 'FWS-SFKGL-SKD-XQ',
          click: (row) => {
            this.handleDetail(row);
          },
        },
        { prop: 'orderNumber', label: '业务订单编号', minWidth: '1', slotName: 'orderNumber' },
        { prop: 'recApplyNo', label: '申请单号', minWidth: '1' },
        { prop: 'typeDesc', label: '收款单类型', minWidth: '1' },
        { prop: 'recBusinessName', label: '客户名称', minWidth: '1' },
        { prop: 'recBusinessNo', label: '客户编号', minWidth: '1' },
        { prop: 'payeeBusinessName', label: '服务商名称', minWidth: '1' },
        { prop: 'serviceTypeDesc', label: '服务商类型', minWidth: '1' },
        { prop: 'receiptTypeDesc', label: '收款方式', minWidth: '1' },
        { prop: 'receiptOrgan', label: '收款渠道', minWidth: '1' },
        { prop: 'receiptAmount', label: '收款单金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'recAccountName', label: '收款户名', minWidth: '1' },
        { prop: 'recAccountBankNameAndNum', label: '收款账户', minWidth: '1' },
        { prop: 'certificate', slotName: 'certificate', label: '收款凭证', minWidth: '1' },
        { prop: 'cruser', label: '申请人', minWidth: '1' },
        {
          label: '收款单状态',
          prop: 'verifiedStatus',
          status: 'verifiedStatus',
          statusDesc: 'verifiedStatusDesc',
          statusColor: (val) => setStatusColor(val, 'receiptStatus'),
        },
        { prop: 'operatorName', label: '确收人', minWidth: '1' },
        { prop: 'crtime', label: '创建时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        {
          label: '操作',
          prop: 'operate',
          width: '100px',
          disabled: true,
          btnGroups: [
            {
              name: '确认',
              plain: true,
              className: ['table-button', 'table-button-success'],
              icon: 'el-icon-success',
              trackCode: 'receivablesReceiptList-4',
              showBtn: (row) => this.$has('FWS-SFKGL-SKD-QR') && this.handleConfirmShow(row),
              click: (row) => this.handleOperateState(1, row),
            },
            {
              name: '取消',
              plain: true,
              className: ['table-button', 'table-button-danger'],
              icon: 'el-icon-error',
              trackCode: 'receivablesReceiptList-5',
              showBtn: (row) => this.$has('FWS-SFKGL-SKD-QX') && this.handleCancelShow(row),
              click: (row) => this.handleCancel(row),
            },
          ],
        },
      ],
      selectTableColumn: [],
      recommendedColumn: [
        { prop: 'waitDivideAmount', label: '待分账金额(元)', minWidth: '1', slotName: 'waitDivideAmount' },
        { prop: 'recApplySerialnumber', label: '渠道流水编号', minWidth: '1' },
        { prop: 'confirmTime', label: '收款确认时间', minWidth: '1', filterName: 'formatTime' },
      ],
      columnsKey: 'fwsReceiptList',
      selectList: [
        {
          title: '服务商类型',
          prop: 'serviceType',
          dictionaryPath: dictTypes.serviceType,
        },
        {
          title: '收款单类型',
          prop: 'type',
          dictionaryPath: dictTypes.FinReceiveTypeEnum,
          attrs: {
            style: 'max-width: 160px;',
          },
        },
        // {
        //   title: '收款方式',
        //   slotName: 'paymentMethods',
        //   dictionaryPath: dictTypes.FinReceiptModelEnum,
        // },
        {
          title: '收款方式',
          slotName: 'receiptMode',
          dictionaryPath: dictTypes.FinReceiptModelEnum_v2,
        },
        {
          title: '收款状态',
          prop: 'verifiedStatus',
          dictionaryPath: dictTypes.FinReceiptStatusEnum,
        },
      ],
      isDetailShow: false, // 详情弹窗
      receiptNo: '', // 收款单编号
      exportType: 'order', // 导出类型
    };
  },
  computed: {
    receiptModeOptions() {
      const { dictData = {} } = this.$store.state.dictionary;
      const arr = _.cloneDeep(dictData[dictTypes.FinReceiptModelEnum_v2]) || [];
      arr.unshift({
        value: 'all',
        codeName: '全部',
      });
      return arr;
    },
    // 导出参数
    exportParams() {
      const params = {
        ...this.searchParams,
        exportType: this.exportType,
      };
      delete params.page;
      delete params.limit;
      return params;
    },
    searchParams() {
      const params = {
        ...this.queryForm,
        sourceList: this.sourceList,
      };
      params[params.searchType] = params.searchKey;
      delete params.searchType;
      delete params.searchKey;
      delete params.selectList;
      return params;
    },
  },
  created() {
    this.resetDate();
    this.init();
  },
  methods: {

    // 关闭导出弹窗
    onCloseExport() {
      this.exportType = 'order';
    },

    // 详情
    handleDetail(row) {
      this.receiptNo = row?.receiptNo || '';
      this.isDetailShow = true;
    },
    async init() {
      this.$store.dispatch('dictionary/getDictionary', { type: 'RECEIPT_FS' });
      const { verifiedStatus, isH, recApplyNos } = this.$route.query;
      this.queryForm.verifiedStatus = verifiedStatus || '';
      this.queryForm.isHspecial = isH || '';
      // 【金融收款超时确认预警】点击跳转到该页面url携带recApplyNos参数
      if (recApplyNos) {
        this.queryForm.searchType = 'recApplyNo';
        this.queryForm.searchKey = recApplyNos;
      }
      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
          recommendedColumn: this.recommendedColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.receiptListRef.doLayout();
      });
    },
    // 收款单确认/取消确认操作返回结果
    handleOperateStateResults() {
      if (this.isBatch) {
        this.handleBatchSearchConfirm(this.batchResults, true);
      } else {
        this.getList();
      }
    },
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      this.batchResults = form;
      const param = { ...formDefault };
      param.searchKey = (form.list || []).join(',');
      param.searchType = form.searchType;
      this.queryForm = { ...param };
      this.getList();
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 搜索
    handleSearch(params = {}) {
      this.queryForm = {
        ...this.queryForm,
        ...params,
        page: 1,
      };
      this.getList();
    },
    resetDate() {
      const { startDate, endDate } = getMonthDate();
      this.queryForm.beginTime = startDate || '';
      this.queryForm.endTime = endDate || '';
    },
    // 列表查询
    async getList() {
      const { searchKey, paymentMethods, verifiedStatus, sourceList, receiptMode } = this.queryForm;
      if (!this.queryForm.beginTime && !(searchKey || paymentMethods || verifiedStatus || sourceList?.length || receiptMode)) {
        this.resetDate();
      }
      try {
        this.loading = true;
        this.list = [];
        /**
         * 除了线下转账及子级外都是线上支付
         * 线下收款方式含：现有的收款方式及渠道
         * 线上收款方式含：线上二维码（及其二级选项）、公众号支付（及其二级选项）、小程序支付（及其二级选项）、账户收款（及其二级选项）、银行卡快捷（及其二级选项）、账期收款（及其二级选项）、金融收款（及其二级选项）
         * */
        const res = await getReceiptList(this.searchParams);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = { ...formDefault };
      this.sourceList = [];
      this.resetDate();
      this.$nextTick(() => {
        this.getList();
      });
    },
    cascaderChange(params) {
      const { selectList, parentSelect, childrenSelect } = params;
      const channels = childrenSelect.length ? childrenSelect.join() : '';
      this.queryForm.selectList = selectList;
      this.queryForm.channels = channels;
      this.queryForm.receiptMode = parentSelect;
      this.refreshList();
    },
  },
};
</script>

<style lang="scss">
.receipt-list {
  padding-bottom: 0px !important;
  padding-left: 14px !important;
  .table-tag {
    margin-bottom: 10px !important;
    margin-right: 8px !important;
  }
}
</style>
